import React, { Fragment } from 'react'
import { Box } from 'stylist'
import withServer from 'components/withServer'
import InfoGroup from 'components/InfoGroup'
import Subheader from 'components/Subheader'
import renderValue from 'utils/renderValue'
import findValue from 'utils/findValue'
import fields from 'fields/servers'

const RouteShow = ({ server }) => (
  <Fragment>
    <h5>Server Information</h5>
    <Box>
      <Box.Item pad>
        {fields.map(field => (
          <InfoGroup key={field.name}>
            <Subheader>{field.label || field.name}:</Subheader>
            <span>{renderValue(findValue(server, field.name))}</span>
          </InfoGroup>
        ))}
      </Box.Item>
    </Box>
  </Fragment>
)

export default withServer(RouteShow)



// WEBPACK FOOTER //
// ./src/routes/admin/servers/show.js